import React, { useEffect } from "react";
import "@/App.css";
import Lenis from '@studio-freight/lenis';
import { Toaster } from "sonner";

// Components
import { Header } from "./components/Header";
import { Hero } from "./components/Hero";
import { Products } from "./components/Products";
import { ProductQuiz } from "./components/ProductQuiz";
import { ComingSoon } from "./components/ComingSoon";
import { FounderStory } from "./components/FounderStory";
import { ContactSection } from "./components/ContactSection";
import { Newsletter } from "./components/Newsletter";
import { Footer } from "./components/Footer";
import { WhatsAppButton } from "./components/WhatsAppButton";

function App() {
  useEffect(() => {
    // Initialize Lenis smooth scrolling
    const lenis = new Lenis({
      duration: 1.2,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      direction: 'vertical',
      gestureDirection: 'vertical',
      smooth: true,
      mouseMultiplier: 1,
      smoothTouch: false,
      touchMultiplier: 2,
      infinite: false,
    });

    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }

    requestAnimationFrame(raf);

    return () => {
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App" data-testid="app-container">
      {/* Grain overlay for texture */}
      <div className="grain-overlay" />
      
      {/* Toast notifications */}
      <Toaster 
        position="top-right" 
        toastOptions={{
          style: {
            background: '#FDFBF7',
            border: '1px solid #E8E4DA',
            color: '#2C2C2C',
          },
        }}
      />

      {/* Header */}
      <Header />

      {/* Main Content */}
      <main>
        <Hero />
        <Products />
        <ProductQuiz />
        <ComingSoon />
        <FounderStory />
        <Newsletter />
        <ContactSection />
      </main>

      {/* Footer */}
      <Footer />

      {/* Floating WhatsApp Button */}
      <WhatsAppButton />
    </div>
  );
}

export default App;
